import styled from "styled-components";

 export const PlaylistIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 5px;
`;
